import type { App, Plugin } from 'vue'
import { useNotify } from '@/composables/useNotify'
import { trackError } from '@/lib/track'

const HandleErrors: Plugin = {
  install(app: App) {
    const notify = useNotify()

    app.config.errorHandler = err => {
      if (err instanceof Error) {
        notify.error(err.message)
        trackError(err.message, 'vue')
      }
    }

    app.config.warnHandler = message => {
      notify.warning(message)
    }

    // Pas de listener 'error' : trop de bruit non actionnable (ResizeObserver, extensions). On ne suit que Vue + promises non catchées.
    window.addEventListener('unhandledrejection', e => {
      const reason = e.reason
      const message =
        reason instanceof Error ? reason.message : String(reason ?? 'unknown')
      trackError(message, 'promise')
    })
  }
}

export default HandleErrors
